/** Lightweight console-only telemetry helpers (OpenTelemetry packages removed). */

export type OtelAttributeScalar = string | number | boolean;

const diagnosticSpanStack: { name: string }[] = [];

export function getDiagnosticLogFields(): Record<string, string> {
  return diagnosticSpanStack.length > 0 ? { span_name: diagnosticSpanStack.at(-1)!.name } : {};
}

export function startDiagnosticTraceSpan(spanName: string): { end: () => void; fail: (err: Error) => void } {
  const span = { name: spanName };
  diagnosticSpanStack.push(span);
  const pop = () => {
    const i = diagnosticSpanStack.lastIndexOf(span);
    if (i >= 0) diagnosticSpanStack.splice(i, 1);
  };
  return {
    end: pop,
    fail: (_err: Error) => {
      pop();
    },
  };
}

export function emitMetricCounter(_name: string, _value: number, _attributes?: Record<string, OtelAttributeScalar>): void {
  /* no-op without OTLP */
}

export function emitMetricHistogram(
  _name: string,
  _value: number,
  _attributes?: Record<string, OtelAttributeScalar>,
): void {
  /* no-op without OTLP */
}

export function emitOtlpStructuredLog(
  _severity: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR',
  _body: string,
  _attributes?: Record<string, unknown>,
): void {
  /* no-op without OTLP */
}

export function ensureBrowserTracing(): void {
  /* no-op without OpenTelemetry SDK */
}

export function getWebTracer() {
  return {
    startSpan(name: string) {
      return startDiagnosticTraceSpan(name);
    },
  };
}
